<template>
    <div>
            <div>
        <loading :active.sync="bigLoading" 
        :can-cancel="false"
        loader="dots"
        color="#007bff"
        :height="45"
        :width="75"
        :is-full-page="fullPage">
        </loading>
    </div>
    <div v-if="done">
        <PrimaryDashboard v-if="dashboard === $config.PRIMARY_DASHBOARD"/>
        <SpaceyDashboard v-else-if="dashboard === $config.SPACEY_DASHBOARD"/>
        <ImportJobLogs v-else-if="dashboard === $config.CRON_LOGS_DASHBOARD"/>
        <Deduplicate v-else-if="dashboard === $config.DEDUPLICATES_DASHBOARD"/>
        <Pagination
            v-if="dashboard !== $config.CRON_LOGS_DASHBOARD"
            :isloading="isloading"
            :startRecord="startRecord"
            :currentPage="currentPage"
            :lastPage="lastPage"
            :lastRecord="lastRecord"
            :totRecords="totRecords"
            :isCurrentPageClass="isCurrentPageClass"
            :perpage="perpage"
            :getLastPageClass="getLastPageClass"
            :totPage="totPage"
            :getPages="getPages"
            @handlePerPage="handlePerPage"
            @paginate="paginate"
            @last="last"
            @getDataByPage="getDataByPage"
        />
        <SearchForm ref="searchFormRef" v-if="dashboard !== $config.CRON_LOGS_DASHBOARD && dashboard !== $config.DEDUPLICATES_DASHBOARD" v-bind:dashboardType="$store.getters['RawData/getDashboardType']"/>
        <DedupSearchForm v-if="dashboard === $config.DEDUPLICATES_DASHBOARD"/>
    </div>
    </div>
</template>

<script>

import PrimaryDashboard from './../dashboards/PrimaryDashboard'
import SpaceyDashboard from './../dashboards/SpaceyDashboard'
import ImportJobLogs from './../dashboards/ImportJobLogs'
import Deduplicate from './Deduplicate'
import SearchForm from './SearchForm'
import Pagination from './Pagination'
import DedupSearchForm from './DedupSearchForm'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from "vuex";

export default {
    name: 'Dashboard',   
    data: () => ({
        fullPage:''
    }),
    components: {
        PrimaryDashboard,
        SpaceyDashboard,
        Deduplicate,
        SearchForm,
        Pagination,
        ImportJobLogs,
        DedupSearchForm,
        Loading
    },
    mounted() {
        this.$store.dispatch("RawData/setBigLoading", true)
        let sidebar = this.$store.getters["RawData/getSidebar"];
        let check =  this
        let current_active_mod = null
        sidebar.forEach((module)=>{
            console.log((check.$route.path.toLowerCase() === '/' && check.$route.path.toLowerCase() === module.to.toLowerCase()  && current_active_mod === null));
        if(check.$route.path.toLowerCase() === '/' && check.$route.path.toLowerCase() === module.to.toLowerCase()  && current_active_mod === null){
            current_active_mod = module 
        }else if(check.$route.path.toLowerCase() !== '/' && module.to.toLowerCase() !== '/' && check.$route.path.toLowerCase().includes(module.to.toLowerCase())  && current_active_mod === null){
        current_active_mod = module
        }
        })
        check.$store.dispatch("RawData/setCurrentActiveModule", current_active_mod)
        if(check.$store.getters['RawData/getDone'] == true){
            check.$store.dispatch("RawData/setBigLoading", false)
        }
    },
    computed: {
         ...mapGetters({
      bigLoading: 'RawData/getBigLoading',
    }),
        dashboard: function() {
            return this.$store.getters['Display/getDisplayDashboard']
        },
        done: function() {
            return this.$store.getters['RawData/getDone']
        },
        isloading: function () {
            if(this.dashboard === this.$config.DEDUPLICATES_DASHBOARD){
                return this.$store.getters['Deduplicate/getIsLoading']
            }else{
                return this.$store.getters['Emails/getIsLoading']
            }
        },
        startRecord: function () {
            return parseInt(this.lastRecord) - parseInt(this.perpage) + parseInt(1)
        },
        currentPage: function () {
            if(this.dashboard === this.$config.DEDUPLICATES_DASHBOARD){
                return this.$store.getters['Deduplicate/getCurrentPage']
            }else{
                return this.$store.getters['Emails/getCurrentPage']
            }
        },
        lastPage: function () {
            if(this.dashboard === this.$config.DEDUPLICATES_DASHBOARD){
                return this.$store.getters['Deduplicate/getLastPage']
            }else{
                return this.$store.getters['Emails/getLastPage']
            }
        },
        lastRecord: function () {
            return this.perpage * this.currentPage
        },
        totRecords: function () {
            var store = this.$store
            if(this.dashboard === this.$config.DEDUPLICATES_DASHBOARD){
                return store.getters['Deduplicate/getTotalDeduplicates']
            }else{
                return store.getters['Display/getDisplayDashboard'] === 'dashboard' ? store.getters['Emails/getTotalEmails'] : store.getters['Emails/getTotalEmails']
            }
        },
        isCurrentPageClass: function () {
            return this.currentPage === 1 ? "" : "notactivespan"
        },
        perpage: function () {
            if(this.dashboard === this.$config.DEDUPLICATES_DASHBOARD){
                return this.$store.getters['Deduplicate/getPerPage']
            }else{
                return this.$store.getters['Emails/getPerPage']
            }
        },
        getLastPageClass: function () {
            return parseInt(this.lastPage) === parseInt(this.currentPage) ? "" : "notactivespan"
        },
        totPage: function () {
            return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage))
        },
        getPages: function () {
            return this.$utils.getPages(this.lastPage, this.currentPage, this.totPage)
        },
    },
    watch:{
        '$store.state.RawData.current_active_module': function(o){
            if(o){
                    var view = this
                if (!view.$store.getters['RawData/getDone']) {
                    view.$fetch({
                        url: view.$url('RAW_DATA'),
                        type: "GET"
                    },{
                        operation: 'view',
                        vueScope: view
                    }).then(function(response) {
                        view.$store.dispatch("RawData/setBigLoading", false)
                        typeof response.totSpacey2019Emails === 'undefined' ? '' : localStorage.setItem('totSpacey2019Emails',response.totSpacey2019Emails)
                        typeof response.totSpacey2019Emails === 'undefined' ? '' : localStorage.setItem('totSpaceyEmails',response.totSpaceyEmails)
                        typeof response.totEmails === 'undefined' ? '' : view.$store.dispatch('Emails/setTotalEmails', response.totEmails).then(() => {
                            typeof response.totSpaceyEmails === 'undefined' ? '' : view.$store.dispatch('Emails/setTotalSpaceyEmails', response.totSpaceyEmails).then(() => {
                                view.$store.dispatch('RawData/setRawData', response).then(() => {
                                    view.$store.dispatch('RawData/setDone', true)
                                })
                            })
                        })
                        typeof response.states === 'undefined' ? '' : view.$store.dispatch('RawData/setStates', response.states)
                    }).catch(function(e) {
                        console.log(e)
                        view.$store.dispatch("RawData/setBigLoading", false)
                    })
                }
            }
        }
    },
    methods: {
        handlePerPage: function(p) {
            console.log('handlePerPage...')
            var view = this;
            if (this.dashboard === this.$config.DEDUPLICATES_DASHBOARD) {
                view.$store.dispatch("Deduplicate/setPerPage", p).then(function () {
                    return view.$store.dispatch("Deduplicate/setPage", parseInt(1));
                }).then(function () {
                  return view.$store.dispatch("Deduplicate/setIsLoading", true);
                }).then(function () {
                  view.$utils.fetchDeduplicates(view);
                }).catch(function (e) {
                  console.log(e);
                });
            } else {
                if (this.dashboard === this.$config.PRIMARY_DASHBOARD) {
                    let updateObjects = view.$store.getters["Emails/getUpdateObjects"];
                    if (Array.isArray(updateObjects) && updateObjects.length) {
                        if (!confirm("Do you really want to continue with unsaved changes?")) {
                            return;
                        }else{
                            let page = view.$store.getters["Emails/getCurrentPage"];
                            view.$store.dispatch("Emails/setPerPage", p).then(function () {
                                return view.$store.dispatch("Emails/setPage", parseInt(1));
                            }).then(function () {
                                return view.$store.dispatch("Emails/setIsLoading", true);
                            }).then(function () {
                                return view.$store.dispatch("Emails/setPagingDataFromDate", {page,totPage: view.totPage,perPage: view.perpage});
                            }).then(function () {
                                return view.$store.dispatch("Emails/setPagingDataFromMuid", {page,totPage: view.totPage,perPage: view.perpage});
                            }).then(function () {
                                // let isFromSearch = view.$store.getters["Search/getIsFromSearch"];
                                // isFromSearch ? view.$utils.search(view) : view.$utils.fetchEmails(view);
                                view.$utils.search(view)  //for sorting
                            }).catch(function (e) {
                                console.log(e);
                            });
                            view.$store.dispatch('Emails/removeAllUpdateObj', [])
                        }
                    } else {
                        let page = view.$store.getters["Emails/getCurrentPage"];
                        view.$store.dispatch("Emails/setPerPage", p).then(function () {
                            return view.$store.dispatch("Emails/setPage", parseInt(1));
                        }).then(function () {
                            return view.$store.dispatch("Emails/setIsLoading", true);
                        }).then(function () {
                            return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                        }).then(function () {
                            return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                        }).then(function () {
                            // let isFromSearch = view.$store.getters["Search/getIsFromSearch"];
                            // isFromSearch ? view.$utils.search(view) : view.$utils.fetchEmails(view);
                            view.$utils.search(view)  //for sorting
                        }).catch(function (e) {
                            console.log(e);
                        });
                        view.$store.dispatch('Emails/removeAllUpdateObj', [])
                    }
                } else {
                    let page = view.$store.getters["Emails/getCurrentPage"];
                    view.$store.dispatch("Emails/setPerPage", p).then(function () {
                        return view.$store.dispatch("Emails/setPage", parseInt(1));
                    }).then(function () {
                        return view.$store.dispatch("Emails/setIsLoading", true);
                    }).then(function () {
                        return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                    }).then(function () {
                        return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                    }).then(function () {
                        // let isFromSearch = view.$store.getters["Search/getIsFromSearch"];
                        // isFromSearch ? view.$utils.search(view) : view.$utils.fetchEmails(view);
                        view.$utils.search(view)  //for sorting
                    }).catch(function (e) {
                        console.log(e);
                    });
                    view.$store.dispatch('Emails/removeAllUpdateObj', [])
                }
            }
        },
        paginate: function (n) {
            console.log('paginate...')
            if (parseInt(n) === parseInt(0) && parseInt(this.currentPage) === parseInt(1)) {
                return;
            }
            if (parseInt(n) === parseInt(-1)) {
                if (parseInt(this.currentPage) <= parseInt(1)) {
                    return;
                }
            }
            if (parseInt(n) === parseInt(1)) {
                if (parseInt(this.currentPage) >= parseInt(this.lastPage)) {
                    return;
                }
            }
            const view = this;
            if (this.dashboard === this.$config.DEDUPLICATES_DASHBOARD) {
                let myPromise = new Promise(function (resolve, reject) {
                    resolve(view.$store.dispatch("Deduplicate/setPage", n === 0 ? 1 : parseInt(view.currentPage) + parseInt(n)));
                    reject("Error: on set page");
                });
                myPromise.then(function () {
                    view.$store.getters['Deduplicate/getIsFromSearch'] ? view.$utils.searchDeduplication(view) : view.$utils.fetchDeduplicates(view);
                }).catch(function (e) {
                    console.log(e);
                });
            } else {
                if (this.dashboard === this.$config.PRIMARY_DASHBOARD) {
                    let updateObjects = view.$store.getters["Emails/getUpdateObjects"];
                    if (Array.isArray(updateObjects) && updateObjects.length) {
                        if (!confirm("Do you really want to continue with unsaved changes?")) {
                            return;
                        }else{
                            let myPromise = new Promise(function (resolve, reject) {
                                resolve(view.$store.dispatch("Emails/setPage", n === 0 ? 1 : parseInt(view.currentPage) + parseInt(n)));
                                reject("Error: on set page");
                            });
                            let page = view.$store.getters["Emails/getCurrentPage"];
                            myPromise.then(function () {
                                return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                            }).then(function () {
                                return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                            }).then(function () {
                                // let isFromSearch = view.$store.getters["Search/getIsFromSearch"];
                                // isFromSearch ? view.$utils.search(view) : view.$utils.fetchEmails(view);
                                view.$utils.search(view)  //for sorting
                            }).catch(function (e) {
                                console.log(e);
                            }); 
                            view.$store.dispatch('Emails/removeAllUpdateObj', [])
                        }
                    } else {
                        let myPromise = new Promise(function (resolve, reject) {
                            resolve(view.$store.dispatch("Emails/setPage", n === 0 ? 1 : parseInt(view.currentPage) + parseInt(n)));
                            reject("Error: on set page");
                        });
                        let page = view.$store.getters["Emails/getCurrentPage"];
                        myPromise.then(function () {
                            return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                        }).then(function () {
                            return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                        }).then(function () {
                            // let isFromSearch = view.$store.getters["Search/getIsFromSearch"];
                            // isFromSearch ? view.$utils.search(view) : view.$utils.fetchEmails(view);
                            view.$utils.search(view)  //for sorting
                        }).catch(function (e) {
                            console.log(e);
                        });
                        view.$store.dispatch('Emails/removeAllUpdateObj', [])
                    }
                } else {
                    let myPromise = new Promise(function (resolve, reject) {
                        resolve(view.$store.dispatch("Emails/setPage", n === 0 ? 1 : parseInt(view.currentPage) + parseInt(n)));
                        reject("Error: on set page");
                    });
                    let page = view.$store.getters["Emails/getCurrentPage"];
                    myPromise.then(function () {
                        return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                    }).then(function () {
                        return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                    }).then(function () {
                        // let isFromSearch = view.$store.getters["Search/getIsFromSearch"];
                        // isFromSearch ? view.$utils.search(view) : view.$utils.fetchEmails(view);
                        view.$utils.search(view)  //for sorting
                    }).catch(function (e) {
                        console.log(e);
                    });
                    view.$store.dispatch('Emails/removeAllUpdateObj', [])
                }
            }
        },
        last: function () {
            console.log('last...')
            const view = this;
            if (this.dashboard === this.$config.DEDUPLICATES_DASHBOARD) {
                if (parseInt(view.lastPage) === parseInt(view.currentPage)) {
                    return;
                }
                view.$store.dispatch("Deduplicate/setPage", view.lastPage).then(function () {
                    view.$store.dispatch("Deduplicate/setIsLoading", true);
                }).then(function () {
                    view.$utils.fetchDeduplicates(view);
                }).catch(function (e) {
                    console.log(e);
                });
            } else {
                if (this.dashboard === this.$config.PRIMARY_DASHBOARD) {
                    let updateObjects = view.$store.getters["Emails/getUpdateObjects"];
                    if (Array.isArray(updateObjects) && updateObjects.length) {
                        if (!confirm("Do you really want to continue with unsaved changes?")) {
                            return;
                        } else {
                            let page = view.$store.getters["Emails/getCurrentPage"];
                            if (parseInt(view.lastPage) === parseInt(view.currentPage)) {
                                return;
                            }
                            view.$store.dispatch("Emails/setPage", view.lastPage).then(function () {
                                view.$store.dispatch("Emails/setIsLoading", true);
                            }).then(function () {
                                return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                            }).then(function () {
                                return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                            }).then(function () {
                                // view.$store.getters["Search/getIsFromSearch"] === true ? view.$utils.search(view) : view.$utils.fetchEmails(view);
                                view.$utils.search(view)  //for sorting
                            }).catch(function (e) {
                                console.log(e);
                            });
                            view.$store.dispatch('Emails/removeAllUpdateObj', [])
                        }
                    } else {
                        let page = view.$store.getters["Emails/getCurrentPage"];
                        if (parseInt(view.lastPage) === parseInt(view.currentPage)) {
                            return;
                        }
                        view.$store.dispatch("Emails/setPage", view.lastPage).then(function () {
                            view.$store.dispatch("Emails/setIsLoading", true);
                          }).then(function () {
                            return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                          }).then(function () {
                            return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                          }).then(function () {
                            // view.$store.getters["Search/getIsFromSearch"] === true ? view.$utils.search(view) : view.$utils.fetchEmails(view);
                            view.$utils.search(view)  //for sorting
                          }).catch(function (e) {
                            console.log(e);
                          });
                          view.$store.dispatch('Emails/removeAllUpdateObj', [])
                    }
                } else {
                    let page = view.$store.getters["Emails/getCurrentPage"];
                    if (parseInt(view.lastPage) === parseInt(view.currentPage)) {
                        return;
                    }
                    view.$store.dispatch("Emails/setPage", view.lastPage).then(function () {
                        view.$store.dispatch("Emails/setIsLoading", true);
                    }).then(function () {
                        return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                    }).then(function () {
                        return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                    }).then(function () {
                        // view.$store.getters["Search/getIsFromSearch"] === true ? view.$utils.search(view) : view.$utils.fetchEmails(view);
                        view.$utils.search(view)  //for sorting
                    }).catch(function (e) {
                        console.log(e);
                    });
                    view.$store.dispatch('Emails/removeAllUpdateObj', [])
                }
            }
        },
        getDataByPage: function (page) {
            console.log('getDataByPage')
            var view = this;
            if (this.dashboard === this.$config.DEDUPLICATES_DASHBOARD) {
                view.$store.dispatch("Deduplicate/setPage", page).then(function () {
                    return view.$store.dispatch("Deduplicate/setIsLoading", true);
                }).then(function () {
                    view.$utils.fetchDeduplicates(view);
                }).catch(function (e) {
                    console.log(e);
                });
            } else {
                if (this.dashboard === this.$config.PRIMARY_DASHBOARD) {
                    let updateObjects = view.$store.getters["Emails/getUpdateObjects"];
                    if (Array.isArray(updateObjects) && updateObjects.length) {
                        if (!confirm("Do you really want to continue with unsaved changes?")) {
                            return;
                        } else {
                            view.$store.dispatch("Emails/setPage", page).then(function () {
                                return view.$store.dispatch("Emails/setIsLoading", true);
                            }).then(function () {
                                return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                            }).then(function () {
                                return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                            }).then(function () {
                                return new Promise(function (resolve) {
                                    resolve(view.$store.getters["Search/getIsFromSearch"]);
                                });
                            }).then(function (response) {
                                if (response === true) {
                                  view.$utils.search(view);
                                } else {
                                  localStorage.getItem("selected_dashboard") === "spacey 2019" ? view.$utils.fetchEmails2019(view) : view.$utils.search(view);
                                }
                            }).catch(function (e) {
                                console.log(e);
                            });
                            view.$store.dispatch('Emails/removeAllUpdateObj', [])
                        }
                    } else {
                        view.$store.dispatch("Emails/setPage", page).then(function () {
                            return view.$store.dispatch("Emails/setIsLoading", true);
                        }).then(function () {
                            return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                        }).then(function () {
                            return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                        }).then(function () {
                            return new Promise(function (resolve) {
                                resolve(view.$store.getters["Search/getIsFromSearch"]);
                            });
                        }).then(function (response) {
                            if (response === true) {
                              view.$utils.search(view);
                            } else {
                              localStorage.getItem("selected_dashboard") === "spacey 2019" ? view.$utils.fetchEmails2019(view) : view.$utils.search(view);
                            }
                        }).catch(function (e) {
                            console.log(e);
                        });
                        view.$store.dispatch('Emails/removeAllUpdateObj', [])
                  }
                } else {
                    view.$store.dispatch("Emails/setPage", page).then(function () {
                        return view.$store.dispatch("Emails/setIsLoading", true);
                    }).then(function () {
                        return view.$store.dispatch("Emails/setPagingDataFromDate", {page, totPage: view.totPage, perPage: view.perpage});
                    }).then(function () {
                        return view.$store.dispatch("Emails/setPagingDataFromMuid", {page, totPage: view.totPage, perPage: view.perpage});
                    }).then(function () {
                        return new Promise(function (resolve) {
                            resolve(view.$store.getters["Search/getIsFromSearch"]);
                        });
                    }).then(function (response) {
                        if (response === true) {
                            view.$utils.search(view);
                        } else {
                            localStorage.getItem("selected_dashboard") === "spacey 2019" ? view.$utils.fetchEmails2019(view) : view.$utils.search(view);
                        }
                    }).catch(function (e) {
                        console.log(e);
                    });
                    view.$store.dispatch('Emails/removeAllUpdateObj', [])
                }
            }
        },
    }
}
</script>